
import Glightbox from "glightbox/src/js/glightbox";
import "glightbox/dist/css/glightbox.css";
import "./functions";
import functions from "./functions";

export default {

    lightbox: null,

    lastScrollPosition: 0,
    scrollThreshold: 50,
    contrastActive: false,
    assetBaseUrl: '',
    contrastCssUrl: '',
    contrastLogoUrl: '',
    logoUrl: '',
    dotsUrl: '',
    contrastDotsUrl: '',

    init() {
        this.assetBaseUrl = window?.Site?.assetBaseUrl ?? '';
        this.assetBaseUrl ? this.contrastCssUrl = this.assetBaseUrl + 'Dist/Css/contrast.min.css' : '';
        this.assetBaseUrl ? this.contrastLogoUrl = this.assetBaseUrl + 'Images/logo-white.svg' : '';
        this.assetBaseUrl ? this.logoUrl = this.assetBaseUrl + 'Images/logo.svg' : '';
        this.assetBaseUrl ? this.dotsUrl = this.assetBaseUrl + 'Icons/dots.svg' : '';
        this.assetBaseUrl ? this.contrastDotsUrl = this.assetBaseUrl + 'Icons/dots-white.svg' : '';
        this.initMenu();
        this.initLightbox();
        this.initHeader();
        this.initContrast();
    },

    async setContrast() {

        const menuDots = document.querySelectorAll('span.menu-dots');
        const changeContrast = document.querySelectorAll(".changeContrast");

        if(this.contrastActive) {
            this.contrastActive = true;
            localStorage.setItem('contrast', "1");
            changeContrast.forEach(cc => cc.classList.add("active"));
            if(this.contrastCssUrl !== "") {
                const link = document.createElement('link');
                link.rel = 'stylesheet';
                link.id = 'cssContrast';
                link.type = 'text/css';
                link.href = this.contrastCssUrl;
                document.head.appendChild(link);
            }
            if(this.contrastLogoUrl !== "") {
                try {
                    const responseLogoWhite = await fetch(this.contrastLogoUrl);
                    if(responseLogoWhite.ok) {
                        const logoLink = document.getElementById('logo-link');
                        logoLink && (logoLink.innerHTML = await responseLogoWhite.text());
                    }
                } catch (error) {
                    console.error('Fehler beim Laden des Kontrast Logos:', error);
                }
            }
            if(this.contrastDotsUrl !== "") {
                try {
                    const responseDotsWhite = await fetch(this.contrastDotsUrl);
                    if(responseDotsWhite.ok) {
                        const menuDotsSvgContent = await responseDotsWhite.text();
                        menuDots.forEach(menuDot => {
                            menuDot.innerHTML = menuDotsSvgContent;
                        });
                    }
                } catch (error) {
                    console.error('Fehler beim Laden der Kontrast Dots:', error);
                }
            }
        }
        else {
            this.contrastActive = false;
            localStorage.removeItem('contrast');
            changeContrast.forEach(cc => cc.classList.remove("active"));
            document.getElementById("cssContrast")?.remove();
            if(this.logoUrl !== "") {
                try {
                    const responseLogo = await fetch(this.logoUrl);
                    if(responseLogo.ok) {
                        document.getElementById('logo-link').innerHTML = await responseLogo.text();
                    }
                } catch (error) {
                    console.error('Fehler beim Laden des Logos:', error);
                }
            }
            if(this.dotsUrl !== "") {
                try {
                    const responseDots = await fetch(this.dotsUrl);
                    if(responseDots.ok) {
                        const menuDotsSvgContent = await responseDots.text();
                        menuDots.forEach(menuDot => {
                            menuDot.innerHTML = menuDotsSvgContent;
                        });
                    }
                } catch (error) {
                    console.error('Fehler beim Laden der Dots:', error);
                }
            }
        }
    },

    initContrast() {
        this.contrastActive = (!!localStorage.getItem("contrast")) ?? false;
        const changeContrast = document.querySelectorAll(".changeContrast");
        this.setContrast().then(r => {});
        changeContrast.forEach(cc => cc.addEventListener("click", async (e) => {
            e.preventDefault();
            this.contrastActive = !this.contrastActive;
            await this.setContrast();
            return false;
        }));
    },

    initHeader() {
        window.addEventListener('scroll', () => {
            const currentScroll = window.scrollY || document.documentElement.scrollTop;

            if (currentScroll > this.scrollThreshold) {
                if (currentScroll > this.lastScrollPosition) {
                    functions.fadeOutLogo();
                }
            } else {
                functions.fadeInLogo();
            }

            this.lastScrollPosition = currentScroll;


        }, { passive: true });

    },

    initLightbox() {
        this.lightbox = Glightbox({
            selector: '.glightbox',
            gallery: true,
            touchNavigation: true,
            loop: true,
            autoplayVideos: true,
        });

        //fix Chrome error aria
        this.lightbox.on('open', () => {
            const activeElement = document.activeElement;
            if (activeElement) {
                activeElement.blur();
            }
        });

    },

    initMenu() {
        const overlayDark = document.getElementById('overlay-dark');
        const submenuItems = document.querySelectorAll('ul.submenu > li:not(.spacer)');
        const submenuItemWraps = document.querySelectorAll('.submenu-item-wrap');
        submenuItems.forEach(item => {
            item.addEventListener('mouseenter', () => {
                submenuItems.forEach(item => item.classList.remove('active'));
                item.classList.add('active');
                submenuItemWraps.forEach(wrap => wrap.classList.remove('active'));
                const submenuItemWrap = document.getElementById(item.dataset.target);
                if(submenuItemWrap) {
                    submenuItemWrap.classList.add('active');
                }

            });
        });

        const menuItems = document.querySelectorAll('nav#menu > ul.menu > li');
        menuItems.forEach(item => {
            item.addEventListener('mouseenter', () => {
                menuItems.forEach(item => item.classList.remove('active'));
                item.classList.add('active');
                overlayDark.classList.remove('d-none');
            });
        });

        const nav = document.querySelector('nav#menu');
        nav.addEventListener('mouseleave', () => {
            menuItems.forEach(item => item.classList.remove('active'));
            overlayDark.classList.add('d-none');
        });
    }


}